/* BaseCreateComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./BaseCreateRenderer");

class BaseCreateComponent extends EventEmitter {
    constructor(logger, title, message, placeholder, value, createBtnLabel, cancelBtnLabel) {
        super();
        this._logger = logger;
        this._titleText = title || "Please specifiy entry name";
        this._message = message;
        this._placeHolderTitle = placeholder || placeholder === "" ? placeholder : "Enter Entry Name";
        this._value = value;
        this._createBtnLabel = createBtnLabel || "Create";
        this._cancelBtnLabel = cancelBtnLabel || "Cancel";
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    get titleText() {
        return this._titleText;
    }
    get logger() {
        return this._logger;
    }
    get message() {
        return this._message;
    }
    get isMessageProvided() {
        return this.message ? true : false;
    }
    get placeHolderTitle() {
        return this._placeHolderTitle;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._titleText = undefined;
                this._message = undefined;
                this._placeHolderTitle = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "BaseCreateComponent.shutdown() error");
            }
        );
    }
    createAction(name) {
        this._context.resolve(name);
    }
    cancelAction(){
        this._context.reject({ userRejected: true });
    }
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = BaseCreateComponent;
